import React, { useState } from 'react';
import { Image, Modal } from 'react-bootstrap';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import closeIcon from '../../../assets/icon/icon-darker-close.svg';
import LoadButton from '../../common/LoadButton';
import "./camp-notes.css";
import { notesViewModel } from './notes.view.model';
import { useAuth } from '../../auth/Auth';
import { getUserProfileUrl } from '../../../utils/camp.utils';
import Blue_Badge from '../../../assets/icon/Verified-badge.svg';
import Cross_Badge from '../../../assets/icon/Unverified.svg';
import { useHistory } from 'react-router-dom';

const ModalHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
    position: 'relative',
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
    width: theme.spacing(10),
    height: theme.spacing(10),
}));

const CloseButton = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    cursor: 'pointer',
}));

const Content = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
    marginTop: theme.spacing(2),
    width: '100%',
}));

const WriteNotesModal = ({ type = 'new', note, selectedDependent, showModal, setShowModal, getNotes }) => {
    const { school } = useAuth();
    const [text, setText] = useState(note?.content ? note?.content : null);
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const closeModal = () => {
        setShowModal(false);
    };

    const onSubmit = () => {
        setLoading(true);
        let data = ''
        if (type === 'new') {
            data = {
                content: text,
                sender: school?.id,
                dependent_id: selectedDependent?.id,
                group_id: selectedDependent?.profile?.group?.id
            }
        } else {
            data = {
                content: text,
                note_id: note.id
            }
        }
        const API = type === 'new' ? notesViewModel.addNote : notesViewModel.updateNote

        API(data).then((res) => {
            getNotes();
            closeModal();
            setLoading(false);
        }).catch((err) => {
            console.log(err)
            setLoading(false);
        })
    }

    const handleNoteChange = (e) => {
        if (e.target.value.length <= 1500) {
            setText(e.target.value);
        }
    };

    return (
        <Modal id="write-delete-modal" className='write-note-modal' show={showModal} onHide={closeModal} centered>
            <ModalHeader>
                <h4 className='write-notes-h4'>{type === 'new' ? 'Write' : 'Edit'} Note</h4>
                {type === 'new' &&
                    <React.Fragment>
                        <StyledAvatar
                            src={getUserProfileUrl(selectedDependent)}
                            alt={selectedDependent?.username}
                        />
                        <Typography variant="h6" gutterBottom className='camp-title'>
                            {selectedDependent?.username} <Image className="blue_badge" src={selectedDependent?.profile?.is_activated ? Blue_Badge : Cross_Badge} />
                        </Typography>
                        <Typography variant="body1" className='camp-captain-mail'>
                            You are writing the note to <a href={`mailto:${selectedDependent?.guardian?.email}`}>{selectedDependent?.guardian?.first_name} {selectedDependent?.guardian?.last_name} {selectedDependent?.guardian?.email}</a> about <span onClick={() => history.push(`/${selectedDependent?.username}`)}>{selectedDependent?.username}</span>
                        </Typography>
                    </React.Fragment>
                }
                <CloseButton onClick={closeModal}>
                    <img src={closeIcon} alt="Close" />
                </CloseButton>
            </ModalHeader>
            <Content>
                {/* <h5 className='label-your-note'>Write your note</h5> */}

                <label className="boxeslevel" htmlFor="text">
                    Write your note
                </label>

                <StyledTextField
                    id="outlined-multiline-static"
                    placeholder="Enter your note here"
                    multiline
                    rows={4}
                    variant="outlined"
                    onChange={handleNoteChange}
                    defaultValue={note?.content}
                    helperText={`${text?.length || 0}/1500`}
                />
                <LoadButton
                    text={type === 'new' ? 'Publish' : 'Republish'}
                    className='gred-btn publish-btn'
                    onClick={onSubmit}
                    isLoading={loading}
                    isDisabled={loading || !text}
                />
            </Content>
        </Modal>
    );
};

export default WriteNotesModal;
